import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=20272064&scoped=true"
import script from "./base-dialog.ts?vue&type=script&lang=ts&external"
export * from "./base-dialog.ts?vue&type=script&lang=ts&external"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=20272064&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20272064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20272064')) {
      api.createRecord('20272064', component.options)
    } else {
      api.reload('20272064', component.options)
    }
    module.hot.accept("./base-dialog.vue?vue&type=template&id=20272064&scoped=true", function () {
      api.rerender('20272064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Dialog/base-dialog.vue"
export default component.exports